<div class="pmc-list">
    <table
        class="ce-data-table compact"
        mat-table
        [dataSource]="pmc"
        matSort
        matSortActive="reportDate"
        matSortDisableClear
        matSortDirection="desc"
        multiTemplateDataRows
        [trackBy]="pmcListTrackBy"
    >
        <ng-container matColumnDef="counters">
            <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear></th>
            <td mat-cell *matCellDef="let pmc">
                <mat-icon
                    svgIcon="card-text-outline"
                    matTooltipClass="pmc-list-tooltip-json"
                    [matTooltip]="pmc.status | json"
                ></mat-icon>
            </td>
        </ng-container>
        <ng-container matColumnDef="channel">
            <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Channel</th>
            <td mat-cell *matCellDef="let pmc">{{ pmc.slot }}{{ pmc.side }}</td>
        </ng-container>
        <ng-container matColumnDef="origin">
            <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Origin</th>
            <td mat-cell *matCellDef="let pmc">
                {{ generatePmcOrigin(pmc?.cabId) }}
            </td>
        </ng-container>
        <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>State</th>
            <td mat-cell *matCellDef="let pmc">{{ pmc.status?.state }} {{ pmc.status?.alarms }}</td>
        </ng-container>
        <ng-container matColumnDef="can">
            <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>CAN addr.</th>
            <td mat-cell *matCellDef="let pmc">
                {{ pmc.canRelative }}
            </td>
        </ng-container>
        <ng-container matColumnDef="dcVoltage">
            <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>DC voltage</th>
            <td mat-cell *matCellDef="let pmc">
                {{ pmc.status?.dcVoltage }}
            </td>
        </ng-container>
        <ng-container matColumnDef="overruns">
            <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>CAN stats</th>
            <td mat-cell *matCellDef="let pmc">
                {{ pmc.status?.canRxOverruns ? 'RX overruns ' + pmc.status?.canRxOverruns : '' }}
                {{ pmc.status?.canRxOverruns && pmc.status?.canTxFail ? ' / ' : '' }}
                {{ pmc.status?.canTxFail ? 'TX fails ' + pmc.status?.canTxFail : '' }}
            </td>
        </ng-container>
        <ng-container matColumnDef="moduleSerial">
            <th
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                disableClear
                matTooltip="Requires firmware 2.2 or newer"
            >
                Module Serial number
            </th>
            <td mat-cell *matCellDef="let pmc">
                {{ pmc.device?.details?.moduleSerialNumber }}
            </td>
        </ng-container>
        <ng-container matColumnDef="generation">
            <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Gen.</th>
            <td mat-cell *matCellDef="let pmc">
                {{ pmc.device?.details?.['generation'] }}
            </td>
        </ng-container>
        <ng-container matColumnDef="canSerial">
            <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>CAN Serial number</th>
            <td mat-cell *matCellDef="let pmc">
                {{ pmc.device?.serialNumber }}
            </td>
        </ng-container>
        <ng-container matColumnDef="present">
            <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Present</th>
            <td mat-cell *matCellDef="let pmc">
                {{ pmc.status?.present }}
            </td>
        </ng-container>
        <ng-container matColumnDef="operatingHours">
            <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Total operating hours</th>
            <td mat-cell *matCellDef="let pmc" class="align-right">
                <span *ngIf="pmc.operatingHours" matTooltip="Since {{ pmc.operatingHoursSince | date: 'dd.MM.yyyy' }}"
                    >{{ pmc.operatingHours | number: '0.1-1' }} h</span
                >
            </td>
        </ng-container>
        <ng-container matColumnDef="manufacturingDate">
            <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Manufacturing Date</th>
            <td mat-cell *matCellDef="let pmc">
                {{ pmc.device?.details?.manufacturingDate | date: 'dd.MM.yyyy' }}
            </td>
        </ng-container>
        <ng-container matColumnDef="bootVersion">
            <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Boot ver</th>
            <td mat-cell *matCellDef="let pmc">
                {{ pmc.device?.details?.bootVersion }}
            </td>
        </ng-container>
        <ng-container matColumnDef="appVersion">
            <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>SW ver</th>
            <td mat-cell *matCellDef="let pmc">
                {{ pmc.device?.details?.applicationVersion }}
            </td>
        </ng-container>
        <ng-container matColumnDef="maxVoltage">
            <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Max. voltage</th>
            <td mat-cell *matCellDef="let pmc">{{ pmc.device?.details?.maxVoltage }} V</td>
        </ng-container>
        <ng-container matColumnDef="boardRevision">
            <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Board revision</th>
            <td mat-cell *matCellDef="let pmc">
                {{ pmc.device?.details?.boardRevision }}
            </td>
        </ng-container>
        <ng-container matColumnDef="flags">
            <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Flags</th>
            <td mat-cell *matCellDef="let pmc">
                {{ pmc.device?.details?.featureFlags?.join(', ') }}
            </td>
        </ng-container>

        <!-- fatal alerts -->
        <ng-container matColumnDef="alerts">
            <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Alerts</th>
            <td mat-cell *matCellDef="let pmc">
                {{ fatalPmcAlerts[pmc.device?.serialNumber]?.join(', ') }}
            </td>
        </ng-container>

        <!-- all alerts and feature flags (only sysadmin for now)  -->
        <ng-container matColumnDef="expanded">
            <td mat-cell *matCellDef="let pmc" [attr.colspan]="columnsToDisplay.length">
                <div [@pmcExpand]="isSameExpandedPmc(pmc) ? 'expanded' : 'collapsed'" fxLayout="row" fxLayoutGap="20px">
                    <div class="detail-block" *ngIf="pmc?.device?.details?.alerts?.length">
                        <div><strong>ALERTS</strong></div>

                        <!-- Grouped by severity level -->
                        <div *ngFor="let level of severityLevels; index as i">
                            <div>
                                <i>{{ level | uppercase }}</i>
                            </div>
                            <div
                                *ngFor="let alert of pmcAlerts[pmc?.canRelative][level]"
                                [ngClass]="{ 'fatal-string': allFatalPmcAlerts.includes(alert) }"
                            >
                                {{ alert }}
                            </div>

                            <br *ngIf="i < severityLevels.length - 1" />
                        </div>
                    </div>

                    <div class="detail-block" *ngIf="pmc?.device?.details?.featureFlags?.length">
                        <div><strong>FLAGS</strong></div>

                        <div *ngFor="let flag of pmc?.device?.details?.featureFlags">
                            {{ flag }}
                        </div>
                    </div>
                </div>
            </td>
        </ng-container>

        <!-- Headings -->
        <tr class="heading" mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>

        <!-- Rows -->
        <tr
            class="row"
            mat-row
            *matRowDef="let pmc; columns: columnsToDisplay"
            [class.hl]="hoveringPmcCanRelativeByCabId[pmc.signedCabId]?.includes(pmc.canRelative)"
            [class.clickable]="['sysadmin'] | ceAccess"
            (mouseenter)="hoveringPmcCanRelativeChangeForPmcList.next(pmc)"
            (mouseleave)="hoveringPmcCanRelativeChangeForPmcList.next(null)"
            (click)="toggleExpandedPmc(pmc)"
            (keydown.enter)="toggleExpandedPmc(pmc)"
        ></tr>
        <ng-container *ceAccess="['sysadmin']">
            <tr class="row expandedPmc" mat-row *matRowDef="let pmc; columns: ['expanded']"></tr>
        </ng-container>
    </table>
</div>
